// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"fd34ad67","701":"fdfa9387"}[chunkId] + ".chunk.js";
};